var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3963 32.0059L0.532535 21.1421C-0.177507 20.4321 -0.177507 19.2809 0.532534 18.5709L11.3963 7.70712C11.7868 7.31659 12.42 7.31659 12.8105 7.70712L13.9676 8.8642C14.3581 9.25473 14.3581 9.88789 13.9676 10.2784L6.20766 18.0383L39 18.0383C39.5523 18.0383 40 18.486 40 19.0383L40 20.6747C40 21.227 39.5523 21.6747 39 21.6747L6.20766 21.6747L13.9676 29.4346C14.3581 29.8251 14.3581 30.4583 13.9676 30.8488L12.8105 32.0059C12.42 32.3964 11.7868 32.3964 11.3963 32.0059Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon_arrow-Left.517f0c4b80038c8371d07dcb1ab42252.svg";
export { ForwardRef as ReactComponent };